import React from 'react';
import { Link, TextField } from '@mui/material';
import {
  TWILIO_CAMPAIGN_DESCRIPTION_MAX_LENGTH,
  TWILIO_CAMPAIGN_DESCRIPTION_MIN_LENGTH,
} from 'constants/twilio/twilioCampaign';

interface CampaignDescriptionFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  trimmedLength: number;
  isValid: boolean;
  onReset: () => void;
  showGuidance?: boolean;
}

export const CampaignDescriptionField = ({
  value,
  onChange,
  trimmedLength,
  isValid,
  onReset,
  showGuidance = true,
}: CampaignDescriptionFieldProps) => (
  <TextField
    variant="outlined"
    color="secondary"
    label="Campaign description"
    onChange={onChange}
    value={value}
    helperText={
      <>
        {`${trimmedLength}/${TWILIO_CAMPAIGN_DESCRIPTION_MAX_LENGTH} (min ${TWILIO_CAMPAIGN_DESCRIPTION_MIN_LENGTH}).`}
        {showGuidance && (
          <>
            {
              ' Pre-filled with the business name and website, review and edit, e.g. include both the legal (DBA) name and the business name. '
            }
            <Link component="button" type="button" onClick={onReset}>
              Reset
            </Link>
          </>
        )}
      </>
    }
    error={trimmedLength > 0 && !isValid}
    multiline
    minRows={4}
    fullWidth
  />
);
